import { locationPin } from '../locationPin'

export function removeLocationPin(id: uui.domain.ui.map.LocationPinId) {
  delete locationPin.pins[id]
}
